import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Video } from 'src/app/models/video.model';
import { UsersService } from 'src/app/services/users.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'user-videos',
  templateUrl: './user-videos.component.html',
  styleUrls: ['./user-videos.component.scss']
})
export class UserVideosComponent implements OnInit, OnDestroy {

  videos: Video[] = []
  dataLoaded: boolean = true
  routerEvents: Subscription
  header: string
  
  constructor(private usersService: UsersService, public router: Router) { }

  ngOnInit(): void {

    this.loadVideos()

    if (this.router.url === '/favorites')
      this.header = "מועדפים"
    else {
      if (this.router.url === '/history')
        this.header = "הסטוריה"
      else
        this.header = "הסרטונים שלי"
    }

    this.routerEvents = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.loadVideos()
      }
    });
  }

  ngOnDestroy() {
    this.routerEvents.unsubscribe();
  }

  clearHistory() {
    // Swal.fire({
    //   title: "An input!",
    //   text: "אנא פרט על הבעיה:",
    //   input:"textarea",
    //   confirmButtonText: 'שליחה',
    //   cancelButtonText:'ביטול',
    //   showCancelButton: true,
    // }).then((result) => {
    //   if (result.value) {
    //     console.log("Result: " + result.value);
    //   }
    // });
    Swal.fire("", "ההסטוריה נמחקה בהצלחה", 'success')
    this.videos =[]
    this.usersService.deleteHistory().subscribe(d =>
    {
      console.log(d)
    })
  }

  loadVideos() {
    this.dataLoaded = false
    this.usersService.getUserVideos(this.router.url, JSON.parse(localStorage.getItem('user')).userId).subscribe(
      v => {
        this.videos = v
        this.dataLoaded = true
        console.log(this.router.url, v)
      },
      err => console.log(err)
    )
  }

  removeVideo(video_Id: string) {
    this.videos = this.videos.filter((video) => video._id !== video_Id);
  }

}
